import React from 'react'

import Grid from '../../../../components/Grid'
import IconClose from '../../../../components/icons/IconClose'
import PromotionBarModal from './PromotionBarModal'
import { getVisibilityStatusFromCookie } from './utils/getVisibilityStatusFromCookie'

import { TPromotionBarData } from '../../../../types/promotionBar'

export type PromotionBarProps = TPromotionBarData

const PromotionBar: React.FC<PromotionBarProps> = (props) => {
  const [showPromotionModal, setShowPromotionModal] = React.useState(false)
  const [showPromotionBar, setShowPromotionBar] = React.useState(false)

  React.useEffect(() => {
    const isHidden = getVisibilityStatusFromCookie()
    setShowPromotionBar(!isHidden)
    setTimeout(() => {
      window.dataLayer?.push({
        event: 'eecPromoImpression',
        ecommerce: {
          promoView: {
            promotions: [
              {
                id: 'promo bar with voucher code',
                name: 'promo bar with voucher code',
                creative: location.pathname,
              },
            ],
          },
        },
      })
    }, 500)
  }, [])

  const handleModalOpenClick = () => {
    setShowPromotionModal(true)
    document.cookie = `voucher=${props.voucherCode}; expires=${getTonight()}; path=/`
    window.dataLayer?.push({
      event: 'eecPromoClick',
      ecommerce: {
        promoClick: {
          promotions: [
            {
              id: 'promo bar with voucher code',
              name: 'promo bar with voucher code',
              creative: location.pathname,
            },
          ],
        },
      },
    })
  }

  const handleModalCloseClick = () => {
    setShowPromotionModal(false)
  }

  const handlePromotionCloseClick = () => {
    setShowPromotionBar(false)
    document.cookie = `promo_bar_hidden=true; expires=${getTonight()}; path=/`
  }

  return (
    <>
      {showPromotionBar && (
        <div className="text-white transition-colors duration-200 bg-sale-red" data-testid="promotion-bar">
          <Grid.Container>
            <Grid.Row>
              <Grid.Col className="relative text-center px-24 py-8">
                <div
                  className="flex cursor-pointer justify-center items-center"
                  onClick={handleModalOpenClick}
                  data-testid="promotion-bar-body"
                >
                  {props.campaignTitle} <b className="border-b mx-8 whitespace-no-wrap">Gutschein aktivieren</b>
                </div>
                <span className="absolute right-0 -mt-12 cursor-pointer" style={{ top: '50%' }}>
                  <IconClose onClick={handlePromotionCloseClick} />
                </span>
              </Grid.Col>
            </Grid.Row>
          </Grid.Container>
        </div>
      )}
      {showPromotionModal && <PromotionBarModal onCloseClick={handleModalCloseClick} {...props} />}
    </>
  )
}

const getTonight = (): Date => {
  const date = new Date()
  return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 22))
}

export default PromotionBar
